export default "__VITE_ASSET__DNN5FLdA__"